<template>
  <button
    role="switch"
    :disabled="disabled"
    class="disabled:pointer-events-none disabled:opacity-25"
    @click="toggle"
  >
    <div
      class="relative inline-block h-8 w-14 rounded-full border transition-colors duration-200 ease-in-out"
      :class="
        isActive
          ? 'bg-primary border-transparent'
          : 'bg-gray-500 border-shade-400'
      "
    >
      <slot name="trigger" :is-active="isActive" @toggle="toggle">
        <div
          class="absolute left-0 mt-[3px] inline-block size-6 rounded-full bg-white shadow transition duration-200 ease-linear focus:outline-none"
          :class="isActive ? 'translate-x-7' : 'left-0 ml-1 bg-primary'"
        />
      </slot>
    </div>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:model-value'])

const isActive = computed({
  get: () => props.modelValue,
  set: (newValue: boolean) => emit('update:model-value', newValue),
})

const toggle = () => {
  isActive.value = !isActive.value
}
</script>
